import { Link } from 'react-router-dom'
import { MarketMoneyPayoutsProvider } from '@/components/analytics/market-money-data'
import { UnitEconomicsView } from '@/components/analytics/UnitEconomicsView'

export default function UnitEconomicsPage() {
  return (
    <div className="h-full overflow-x-hidden overflow-y-auto bg-ivory">
      <div className="mx-auto max-w-[1534px] px-4 py-4 pb-[calc(24px+env(safe-area-inset-bottom))] sm:px-6 sm:py-7">
        <header className="mb-4 sm:mb-6">
          <Link to="/analytics" className="eyebrow hover:text-ink">← Аналитика</Link>
          <h1 className="mt-1.5 text-[23px] font-semibold tracking-[-0.02em] text-ink sm:text-[30px]">Юнит-экономика</h1>
        </header>
        <MarketMoneyPayoutsProvider>
          <UnitEconomicsView />
        </MarketMoneyPayoutsProvider>
      </div>
    </div>
  )
}
